import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { getCustomerConfiguration } from '@app/services/api/getCustomerConfiguration'
import { ApiCustomerConfiguration } from '@app/types/customerConfiguration'

export const useConfiguration = (): UseQueryResult<ApiCustomerConfiguration> =>
  useQuery({ queryKey: ['CUSTOMER_CONFIGURATION_QUERY_ID'], queryFn: getCustomerConfiguration, staleTime: Infinity })
